import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { Helmet } from "react-helmet-async";
import CashFlowBalancesHistoryFilter from "./CashFlowBalancesHistoryFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import CashFlowBalancesHistoryList from "./CashFlowBalancesHistoryList";
import { useTranslation } from "react-i18next";

import { StyledBalanceHistoryWrapper } from "./styledBalanceHistory";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const CashFlowBalancesHistoryContainer = () => {
  const { t } = useTranslation("cashFlow");
  const [balancesHistory, setBalancesHistory] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "balances-history", false, true),
    "currency": checkFilterItem(history, "currency", null),
    "service": checkFilterItem(history, "service", null),
    "operationId": checkFilterItem(history, "operationId", null),
    "createAt[gte]": checkFilterItem(history, "createAt[gte]", null, true),
    "createAt[lte]": checkFilterItem(history, "createAt[lte]", null, true)
  });

  const fetchBalancesHistory = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/balance-histories" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setBalancesHistory(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchBalancesHistory();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledBalanceHistoryWrapper>
        <Helmet>
          <title>{t("balancesHistory.meta.title")}</title>
        </Helmet>
        <div className="content-head balance-history-head">
          <CashFlowBalancesHistoryFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <CashFlowBalancesHistoryList
          balancesHistory={balancesHistory}
        />
        {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
      </StyledBalanceHistoryWrapper>
    </>
  );
};

export default CashFlowBalancesHistoryContainer;